import {ActivationChannel, ActivationPolicy} from '../../domain/entities/Activation.ts'
import {normalizeMarketValue} from '../agenciesTable/marketOptions.ts'

// The policy markets the backend seeds (contract §1.3). Anything else reads DEFAULT.
const POLICY_MARKETS = ['US', 'UK', 'ES', 'IT'] as const

// agency.primaryMarket → policy market: legacy slugs ('usa', 'spain'…) are
// normalized to ISO alpha-2, and ISO's GB is the contract's UK.
export function activationPolicyMarket(primaryMarket?: string): string {
    const iso = normalizeMarketValue(primaryMarket)?.toUpperCase()
    const market = iso === 'GB' ? 'UK' : iso
    return market && (POLICY_MARKETS as readonly string[]).includes(market) ? market : 'DEFAULT'
}

// Used only if GET /activation-policies/{market} fails, so the dialog still asks
// for the right contact. Mirrors the seeded values in §1.3.
export function fallbackActivationPolicy(market: string): ActivationPolicy {
    const requiredContact = market === 'ES' || market === 'IT' ? 'PHONE' : 'EMAIL'
    return {market, requiredContact, preferredContact: market === 'US' ? 'PHONE' : null}
}

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
export const isValidEmail = (email: string) => EMAIL_PATTERN.test(email.trim())
// Loose on purpose: formats vary per market and the backend owns validation.
export const isValidPhone = (phone: string) => phone.replace(/\D/g, '').length >= 7

// Whether the contact the market requires is present (and the email, if any,
// looks like one). "No lo tengo" (noContact) waives the requirement: route B.
export function isActivationContactValid(policy: ActivationPolicy, noContact: boolean, email: string, phone: string): boolean {
    if (email.trim() && !isValidEmail(email)) return false
    if (noContact) return true
    return policy.requiredContact === 'EMAIL' ? isValidEmail(email) : isValidPhone(phone)
}

// Phase 2 only sends email, so email wins when both are there.
export function preferredChannelFor(email: string, phone: string): ActivationChannel | undefined {
    if (email.trim()) return 'EMAIL'
    if (phone.trim()) return 'PHONE'
    return undefined
}
